import React from 'react';

type OwnProps = {
  className?: string;
};

const SmallFilledAccount = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    className={className}
  >
    <g>
      <g>
        <path
          fill="#00aed9"
          d="M22 10.996a11 11 0 1 0-18 8.49v-.16a5.35 5.35 0 0 1 4.77-5.33 4.33 4.33 0 1 1 4.46 0 5.35 5.35 0 0 1 4.77 5.33v.16a11 11 0 0 0 4-8.49z"
        />
      </g>
    </g>
  </svg>
);

export default SmallFilledAccount;
